<template>
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.206685 3.33932C0.482264 3.02733 0.929067 3.02733 1.20465 3.33932L4.08765 6.60319C4.36323 6.91518 4.36323 7.42101 4.08765 7.733C3.81207 8.04498 3.36527 8.04498 3.08969 7.733L0.206685 4.46912C-0.068895 4.15714 -0.0688948 3.65131 0.206685 3.33932Z"
      fill="#F18E35"
    />
    <path
      d="M3.14023 7.76601C2.86465 7.45402 2.86465 6.94819 3.14023 6.63621L8.79535 0.23399C9.07093 -0.0779967 9.51774 -0.0779966 9.79331 0.23399C10.0689 0.545976 10.0689 1.05181 9.79332 1.36379L4.1382 7.76601C3.86262 8.078 3.41581 8.078 3.14023 7.76601Z"
      fill="#F18E35"
    />
  </svg>
</template>

<script>
export default {
  name: "DoneIcon",
};
</script>

<style scoped></style>
